import {
    useState
} from "react";
import {
    useWindowDimensions,
    StyleSheet,
    ScrollView,
    View
} from "react-native";
import {
    BrandMark
} from "./brand";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    AvatarGroup,
    Breadcrumb,
    Pagination,
    Accordion,
    TextInput,
    Separator,
    Avatar,
    Button,
    Badge,
    Card,
    Chip,
    Icon,
    Item,
    Tabs,
    Text,
    Kbd
} from "ncore-ui-kit";
import {
    useDocsI18n
} from "../i18n";
import {
    ChevronUp,
    Layers,
    Search,
    Check,
    Plus,
    Bell,
    Pin
} from "lucide-react-native";
import {
    createKitIcon
} from "../components/kitIcons";

const SearchIcon = createKitIcon(Search);

const BellIcon = createKitIcon(Bell);

const PlusIcon = createKitIcon(Plus);

const PinIcon = createKitIcon(Pin);

const CheckIcon = createKitIcon(Check);

const ChevronUpIcon = createKitIcon(ChevronUp);

type Thread = {
    lastMinutes: number;
    last: Array<string>;
    tags: Array<string>;
    isSolved?: boolean;
    isPinned?: boolean;
    ageMinutes: number;
    replies: number;
    author: string;
    votes: number;
    views: number;
    key: string;
};

const NAV = [
    "feed",
    "discover",
    "forum",
    "events"
] as const;

const THREADS: Array<Thread> = [
    {
        tags: ["announcement"],
        ageMinutes: 129600,
        lastMinutes: 2880,
        author: "zeynep",
        isPinned: true,
        key: "welcome",
        replies: 12,
        views: 4800,
        last: [
            "mert",
            "can"
        ],
        votes: 86
    },
    {
        tags: [
            "token",
            "architecture"
        ],
        ageMinutes: 5760,
        lastMinutes: 18,
        author: "mert",
        isSolved: true,
        key: "layers",
        last: [
            "zeynep",
            "selin",
            "emre"
        ],
        replies: 38,
        views: 3200,
        votes: 64
    },
    {
        tags: [
            "accessibility",
            "darkTheme"
        ],
        key: "darkBorder",
        ageMinutes: 2880,
        author: "defne",
        lastMinutes: 60,
        last: [
            "can",
            "zeynep",
            "mert"
        ],
        replies: 27,
        views: 2100,
        votes: 41
    },
    {
        ageMinutes: 4320,
        key: "figmaSync",
        lastMinutes: 180,
        tags: [
            "figma",
            "automation"
        ],
        author: "can",
        replies: 19,
        views: 1700,
        last: [
            "emre",
            "mert"
        ],
        votes: 37
    },
    {
        lastMinutes: 1440,
        ageMinutes: 7200,
        tags: [
            "component",
            "api"
        ],
        author: "emre",
        key: "variant",
        last: [
            "selin",
            "zeynep"
        ],
        replies: 22,
        views: 1400,
        votes: 29
    },
    {
        tags: [
            "reactNative",
            "accessibility"
        ],
        ageMinutes: 10080,
        lastMinutes: 1440,
        author: "selin",
        last: ["mert"],
        key: "focus",
        replies: 9,
        views: 960,
        votes: 18
    },
    {
        key: "changelog",
        lastMinutes: 360,
        ageMinutes: 360,
        author: "ayse",
        last: ["ayse"],
        tags: ["docs"],
        replies: 0,
        views: 84,
        votes: 12
    },
    {
        ageMinutes: 10080,
        lastMinutes: 2880,
        author: "burak",
        key: "density",
        tags: [
            "spacing",
            "density"
        ],
        last: [
            "zeynep",
            "defne"
        ],
        replies: 14,
        views: 780,
        votes: 9
    },
    {
        ageMinutes: 20160,
        key: "iconStroke",
        lastMinutes: 5760,
        author: "elif",
        tags: ["icon"],
        last: [
            "can",
            "selin"
        ],
        replies: 5,
        views: 540,
        votes: 6
    }
];

const FILTERS = [
    "token",
    "component",
    "accessibility",
    "figma",
    "reactNative"
] as const;

const STATS = [
    {
        key: "threads",
        value: 1284
    },
    {
        key: "replies",
        value: 9612
    },
    {
        key: "members",
        value: 3470
    },
    {
        key: "thisWeek",
        value: 86
    }
] as const;

const RULES = [
    "one",
    "two",
    "three",
    "four"
] as const;

const PEOPLE = [
    {
        badge: "expert",
        key: "mert",
        count: 128
    },
    {
        badge: "expert",
        key: "selin",
        count: 97
    },
    {
        badge: "contributor",
        key: "defne",
        count: 84
    },
    {
        badge: "contributor",
        key: "can",
        count: 71
    },
    {
        badge: "contributor",
        key: "emre",
        count: 58
    }
] as const;

const READERS = [
    "can",
    "selin",
    "mert"
];

const TOTAL_THREADS = 1284;

const UNANSWERED_COUNT = 23;

const PAGE_SIZE = 9;

const stylesheet = StyleSheet.create({
    header: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        width: "100%"
    },
    spread: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row"
    },
    iconTile: {
        justifyContent: "center",
        alignItems: "center"
    },
    start: {
        alignItems: "flex-start"
    },
    page: {
        alignItems: "center",
        minHeight: "100%",
        flexGrow: 1
    },
    wrap: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    row: {
        alignItems: "center",
        flexDirection: "row"
    },
    vote: {
        alignItems: "center"
    },
    num: {
        textAlign: "right"
    },
    shrink: {
        flexShrink: 1,
        minWidth: 0
    },
    shell: {
        width: "100%"
    },
    grow: {
        flex: 1,
        flexGrow: 1
    }
});

const handlePress = () => undefined;

const Forum01 = () => {
    const {
        t
    } = useDocsI18n();

    const {
        activeLocale
    } = NCoreUIKitLocalize.useContext();

    const {
        shapeConfigs,
        avatarSizes,
        spaces
    } = NCoreUIKitTheme.useContext();

    const {
        width
    } = useWindowDimensions();

    const [
        tab,
        setTab
    ] = useState("latest");

    const [
        tag,
        setTag
    ] = useState<string | undefined>(undefined);

    const [
        votedKeys,
        setVotedKeys
    ] = useState<Array<string>>([]);

    const [
        isWatching,
        setIsWatching
    ] = useState(false);

    const [
        page,
        setPage
    ] = useState(1);

    const [
        search,
        setSearch
    ] = useState("");

    const isWide = width >= shapeConfigs.wideBreakpoint;

    const isCompact = width < shapeConfigs.compactBreakpoint;

    const isTable = width >= shapeConfigs.wideBreakpoint + shapeConfigs.sideListWidth;

    const number = new Intl.NumberFormat(activeLocale);

    const compact = new Intl.NumberFormat(activeLocale, {
        maximumFractionDigits: 1,
        notation: "compact"
    });

    const relative = new Intl.RelativeTimeFormat(activeLocale, {
        numeric: "always",
        style: "long"
    });

    const formatAge = (minutes: number) => {
        if(minutes < 60) {
            return relative.format(-minutes, "minute");
        }

        if(minutes < 1440) {
            return relative.format(-Math.round(minutes / 60), "hour");
        }

        if(minutes < 10080) {
            return relative.format(-Math.round(minutes / 1440), "day");
        }

        if(minutes < 43200) {
            return relative.format(-Math.round(minutes / 10080), "week");
        }

        return relative.format(-Math.round(minutes / 43200), "month");
    };

    const matching = THREADS.filter((thread) => !tag || thread.tags.includes(tag));

    const threads = matching
        .filter((thread) => tab !== "unanswered" || thread.replies === 0)
        .sort((first, second) => {
            if(first.isPinned !== second.isPinned) {
                return first.isPinned ? -1 : 1;
            }

            return tab === "popular" ? second.votes - first.votes : first.lastMinutes - second.lastMinutes;
        });

    const handleTabChange = (value: string) => {
        setTab(value);

        setPage(1);
    };

    const handleTagPress = (key?: string) => () => {
        setTag(key === tag ? undefined : key);

        setPage(1);
    };

    const handleVotePress = (key: string) => () => setVotedKeys(votedKeys.includes(key) ? votedKeys.filter((item) => item !== key) : [
        ...votedKeys,
        key
    ]);

    const handleWatchPress = () => setIsWatching(!isWatching);

    const renderNav = (key: string) => <Button
        variant={key === "forum" ? "tonal" : "ghost"}
        title={t(`blocks.forum01.nav.${key}`)}
        spreadBehaviour="free"
        onPress={handlePress}
        type="neutral"
        size="small"
        key={key}
    />;

    const renderFilter = (key: string) => <Chip
        title={t(`blocks.forum01.tag.${key}`)}
        onPress={handleTagPress(key)}
        isSelected={tag === key}
        spreadBehaviour="free"
        variant="outline"
        type="neutral"
        key={key}
    />;

    const renderThread = (thread: Thread, index: number) => {
        const isVoted = votedKeys.includes(thread.key);

        const votes = thread.votes + (isVoted ? 1 : 0);

        const lastAvatars = thread.last.map((person) => ({
            title: t(`blocks.forum01.person.${person}`)
        }));

        return <View
            key={thread.key}
        >
            {
                index === 0 ?
                    null
                :
                    <Separator/>
            }
            <View
                style={[
                    stylesheet.row,
                    {
                        padding: spaces.spacingMd,
                        gap: spaces.spacingMd
                    }
                ]}
            >
                <View
                    style={[
                        stylesheet.vote,
                        {
                            width: avatarSizes.medium
                        }
                    ]}
                >
                    <Button
                        accessibilityLabel={t("blocks.forum01.upvote", [
                            votes
                        ])}
                        variant={isVoted ? "tonal" : "ghost"}
                        onPress={handleVotePress(thread.key)}
                        spreadBehaviour="free"
                        accessibilityState={{
                            selected: isVoted
                        }}
                        icon={ChevronUpIcon}
                        type="neutral"
                        size="small"
                    />
                    <Text
                        variant="titleSmallSize"
                        color="high"
                    >
                        {number.format(votes)}
                    </Text>
                </View>
                <View
                    style={[
                        stylesheet.shrink,
                        {
                            gap: spaces.spacingSm,
                            flex: 1
                        }
                    ]}
                >
                    {
                        thread.isPinned || thread.isSolved ?
                            <View
                                style={[
                                    stylesheet.wrap,
                                    {
                                        alignItems: "center",
                                        gap: spaces.spacingSm
                                    }
                                ]}
                            >
                                {
                                    thread.isPinned ?
                                        <Badge
                                            title={t("blocks.forum01.pinned")}
                                            spreadBehaviour="free"
                                            icon={PinIcon}
                                            type="neutral"
                                        />
                                    :
                                        null
                                }
                                {
                                    thread.isSolved ?
                                        <Badge
                                            title={t("blocks.forum01.solved")}
                                            spreadBehaviour="free"
                                            icon={CheckIcon}
                                            type="success"
                                        />
                                    :
                                        null
                                }
                            </View>
                        :
                            null
                    }
                    <Text
                        accessibilityRole="header"
                        variant="titleMediumSize"
                        color="high"
                    >
                        {t(`blocks.forum01.thread.${thread.key}`)}
                    </Text>
                    <View
                        style={[
                            stylesheet.wrap,
                            {
                                alignItems: "center",
                                gap: spaces.spacingSm
                            }
                        ]}
                    >
                        {
                            thread.tags.map((key) => <Badge
                                title={t(`blocks.forum01.tag.${key}`)}
                                spreadBehaviour="free"
                                variant="outline"
                                type="neutral"
                                key={key}
                            />)
                        }
                        <View
                            style={[
                                stylesheet.row,
                                {
                                    gap: spaces.spacingXs
                                }
                            ]}
                        >
                            <Avatar
                                title={t(`blocks.forum01.person.${thread.author}`)}
                                size="xxSmall"
                            />
                            <Text
                                variant="bodySmallSize"
                                color="mid"
                            >
                                {`${t(`blocks.forum01.person.${thread.author}`)} · ${formatAge(thread.ageMinutes)}`}
                            </Text>
                        </View>
                    </View>
                    {
                        isTable ?
                            null
                        :
                            <View
                                style={[
                                    stylesheet.row,
                                    stylesheet.wrap,
                                    {
                                        columnGap: spaces.spacingMd,
                                        rowGap: spaces.spacingXs
                                    }
                                ]}
                            >
                                <Text
                                    variant="bodySmallSize"
                                    color="mid"
                                >
                                    {t("blocks.forum01.repliesCount", [
                                        number.format(thread.replies)
                                    ])}
                                </Text>
                                <Text
                                    variant="bodySmallSize"
                                    color="mid"
                                >
                                    {t("blocks.forum01.viewsCount", [
                                        compact.format(thread.views)
                                    ])}
                                </Text>
                                <Text
                                    variant="bodySmallSize"
                                    color="mid"
                                >
                                    {formatAge(thread.lastMinutes)}
                                </Text>
                            </View>
                    }
                </View>
                {
                    isTable ?
                        <>
                            <Text
                                style={[
                                    stylesheet.num,
                                    {
                                        width: avatarSizes.large
                                    }
                                ]}
                                variant="bodyMediumSize"
                                color="high"
                            >
                                {number.format(thread.replies)}
                            </Text>
                            <Text
                                style={[
                                    stylesheet.num,
                                    {
                                        width: avatarSizes.xLarge - spaces.spacingMd
                                    }
                                ]}
                                variant="bodyMediumSize"
                                color="mid"
                            >
                                {compact.format(thread.views)}
                            </Text>
                            <View
                                style={[
                                    stylesheet.start,
                                    {
                                        width: shapeConfigs.sideListWidth * 0.6,
                                        gap: spaces.spacingXs
                                    }
                                ]}
                            >
                                <AvatarGroup
                                    avatars={lastAvatars}
                                    size="xxSmall"
                                />
                                <Text
                                    variant="bodySmallSize"
                                    color="mid"
                                >
                                    {formatAge(thread.lastMinutes)}
                                </Text>
                            </View>
                        </>
                    :
                        null
                }
            </View>
        </View>;
    };

    const renderStat = ({
        value,
        key
    }: typeof STATS[number]) => <View
        style={{
            flexBasis: shapeConfigs.fieldMinWidth * 0.4,
            flexGrow: 1
        }}
        key={key}
    >
        <Text
            variant="titleLargeSize"
            color="high"
        >
            {number.format(value)}
        </Text>
        <Text
            variant="bodySmallSize"
            color="mid"
        >
            {t(`blocks.forum01.stat.${key}`)}
        </Text>
    </View>;

    const renderRule = (key: string) => <Accordion.Item
        value={key}
        key={key}
    >
        <Accordion.Trigger
            title={t(`blocks.forum01.rule.${key}`)}
            headingLevel={3}
        />
        <Accordion.Content>
            <Text
                variant="bodyMediumSize"
                color="mid"
            >
                {t(`blocks.forum01.rule.${key}Body`)}
            </Text>
        </Accordion.Content>
    </Accordion.Item>;

    const renderPerson = ({
        badge,
        count,
        key
    }: typeof PEOPLE[number], index: number) => <Item
        size="xSmall"
        key={key}
    >
        <Text
            variant="bodySmallSize"
            color="mid"
        >
            {index + 1}
        </Text>
        <Item.Media
            avatarProps={{
                title: t(`blocks.forum01.person.${key}`)
            }}
            variant="avatar"
        />
        <Item.Content>
            <Item.Title>
                {t(`blocks.forum01.person.${key}`)}
            </Item.Title>
            <Item.Description>
                {t("blocks.forum01.answers", [
                    count
                ])}
            </Item.Description>
        </Item.Content>
        <Item.Actions>
            <Badge
                title={t(`blocks.forum01.badge.${badge}`)}
                spreadBehaviour="free"
                variant="outline"
                type="neutral"
            />
        </Item.Actions>
    </Item>;

    return <ScrollView
        contentContainerStyle={stylesheet.page}
    >
        <View
            style={[
                stylesheet.header,
                {
                    maxWidth: shapeConfigs.wideBreakpoint + shapeConfigs.sideListWidth,
                    paddingHorizontal: isCompact ? spaces.spacingMd : spaces.spacingLg,
                    paddingVertical: spaces.spacingSm,
                    gap: spaces.spacingSm
                }
            ]}
        >
            <View
                style={[
                    stylesheet.row,
                    {
                        gap: spaces.spacingMd
                    }
                ]}
            >
                <BrandMark/>
                {
                    isCompact ?
                        null
                    :
                        <Badge
                            title={t("blocks.forum01.community")}
                            spreadBehaviour="free"
                            type="neutral"
                        />
                }
                {
                    isWide ?
                        <View
                            style={[
                                stylesheet.row,
                                {
                                    gap: spaces.spacingXs
                                }
                            ]}
                        >
                            {NAV.map(renderNav)}
                        </View>
                    :
                        null
                }
            </View>
            <View
                style={[
                    stylesheet.row,
                    {
                        gap: spaces.spacingSm
                    }
                ]}
            >
                {
                    isCompact ?
                        null
                    :
                        <View
                            style={{
                                width: shapeConfigs.fieldMinWidth + spaces.spacingXxl
                            }}
                        >
                            <TextInput
                                placeholder={t("blocks.forum01.searchPlaceholder")}
                                accessibilityLabel={t("blocks.forum01.search")}
                                spreadBehaviour="stretch"
                                onChangeText={setSearch}
                                icon={SearchIcon}
                                value={search}
                                size="small"
                            />
                        </View>
                }
                {
                    isWide ?
                        <Kbd
                            keys="/"
                        />
                    :
                        null
                }
                <Badge.Indicator
                    type="danger"
                >
                    <Button
                        accessibilityLabel={t("blocks.forum01.notifications")}
                        spreadBehaviour="free"
                        onPress={handlePress}
                        icon={BellIcon}
                        variant="ghost"
                        type="neutral"
                        size="small"
                    />
                </Badge.Indicator>
                <Avatar
                    title={t("blocks.forum01.me")}
                    size="xSmall"
                />
            </View>
        </View>
        <Separator
            length="100%"
        />
        <View
            style={[
                stylesheet.shell,
                {
                    maxWidth: shapeConfigs.wideBreakpoint + shapeConfigs.sideListWidth,
                    paddingHorizontal: isCompact ? spaces.spacingMd : spaces.spacingLg,
                    paddingVertical: spaces.spacingLg,
                    gap: spaces.spacingXl
                }
            ]}
        >
            <Breadcrumb
                accessibilityLabel={t("blocks.forum01.breadcrumb")}
            >
                <Breadcrumb.List>
                    <Breadcrumb.Item>
                        <Breadcrumb.Link
                            title={t("blocks.forum01.nav.forum")}
                            onPress={handlePress}
                        />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Breadcrumb.Page
                            title={t("blocks.forum01.title")}
                        />
                    </Breadcrumb.Item>
                </Breadcrumb.List>
            </Breadcrumb>
            <View
                style={[
                    stylesheet.wrap,
                    {
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: spaces.spacingMd
                    }
                ]}
            >
                <View
                    style={[
                        stylesheet.row,
                        stylesheet.shrink,
                        {
                            flexBasis: shapeConfigs.cardWidth,
                            alignItems: "flex-start",
                            gap: spaces.spacingMd,
                            flexGrow: 1
                        }
                    ]}
                >
                    <Card
                        variant="outline"
                    >
                        <Card.Content>
                            <Icon
                                icon={Layers}
                                size="large"
                            />
                        </Card.Content>
                    </Card>
                    <View
                        style={[
                            stylesheet.shrink,
                            {
                                gap: spaces.spacingXs,
                                flex: 1
                            }
                        ]}
                    >
                        <Text
                            variant="headlineMediumSize"
                            accessibilityRole="header"
                            color="high"
                        >
                            {t("blocks.forum01.title")}
                        </Text>
                        <Text
                            style={{
                                maxWidth: shapeConfigs.readingMaxWidth + shapeConfigs.fieldMinWidth
                            }}
                            variant="bodyLargeSize"
                            color="mid"
                        >
                            {t("blocks.forum01.description")}
                        </Text>
                    </View>
                </View>
                <View
                    style={[
                        stylesheet.row,
                        {
                            gap: spaces.spacingSm
                        }
                    ]}
                >
                    <Button
                        title={t(isWatching ? "blocks.forum01.watching" : "blocks.forum01.watch")}
                        variant={isWatching ? "tonal" : "ghost"}
                        onPress={handleWatchPress}
                        spreadBehaviour="free"
                        icon={BellIcon}
                        type="neutral"
                    />
                    <Button
                        title={t("blocks.forum01.newTopic")}
                        spreadBehaviour="free"
                        onPress={handlePress}
                        variant="filled"
                        icon={PlusIcon}
                        type="primary"
                    />
                </View>
            </View>
            <View
                style={{
                    flexDirection: isWide ? "row" : "column",
                    alignItems: "flex-start",
                    gap: spaces.spacingLg
                }}
            >
                <View
                    style={[
                        stylesheet.shrink,
                        {
                            width: isWide ? undefined : "100%",
                            flex: isWide ? 1 : undefined,
                            gap: spaces.spacingMd
                        }
                    ]}
                >
                    <Tabs
                        onValueChange={handleTabChange}
                        variant="line"
                        value={tab}
                    >
                        <Tabs.List
                            title={t("blocks.forum01.sortTitle")}
                        >
                            <Tabs.Trigger
                                title={t("blocks.forum01.tabLatest")}
                                value="latest"
                            />
                            <Tabs.Trigger
                                title={t("blocks.forum01.tabPopular")}
                                value="popular"
                            />
                            <Tabs.Trigger
                                title={t("blocks.forum01.tabUnanswered")}
                                count={UNANSWERED_COUNT}
                                value="unanswered"
                            />
                        </Tabs.List>
                    </Tabs>
                    <View
                        style={[
                            stylesheet.row,
                            stylesheet.wrap,
                            {
                                gap: spaces.spacingSm
                            }
                        ]}
                    >
                        <Text
                            variant="bodySmallSize"
                            color="mid"
                        >
                            {t("blocks.forum01.tagLabel")}
                        </Text>
                        <Chip
                            onPress={handleTagPress(undefined)}
                            title={t("blocks.forum01.tagAll")}
                            isSelected={tag === undefined}
                            spreadBehaviour="free"
                            variant="outline"
                            type="neutral"
                        />
                        {FILTERS.map(renderFilter)}
                        <Chip
                            title={t("blocks.forum01.tagMore", [
                                12
                            ])}
                            spreadBehaviour="free"
                            onPress={handlePress}
                            variant="outline"
                            type="neutral"
                        />
                    </View>
                    <Card
                        accessibilityLabel={t("blocks.forum01.threadsLabel")}
                        variant="outline"
                    >
                        {
                            isTable ?
                                <View
                                    style={[
                                        stylesheet.row,
                                        {
                                            paddingHorizontal: spaces.spacingMd,
                                            gap: spaces.spacingMd
                                        }
                                    ]}
                                >
                                    <Text
                                        style={[
                                            stylesheet.vote,
                                            {
                                                width: avatarSizes.medium,
                                                textAlign: "center"
                                            }
                                        ]}
                                        variant="bodySmallSize"
                                        color="mid"
                                    >
                                        {t("blocks.forum01.colVotes")}
                                    </Text>
                                    <Text
                                        style={stylesheet.grow}
                                        variant="bodySmallSize"
                                        color="mid"
                                    >
                                        {t("blocks.forum01.colTopic")}
                                    </Text>
                                    <Text
                                        style={[
                                            stylesheet.num,
                                            {
                                                width: avatarSizes.large
                                            }
                                        ]}
                                        variant="bodySmallSize"
                                        color="mid"
                                    >
                                        {t("blocks.forum01.colReplies")}
                                    </Text>
                                    <Text
                                        style={[
                                            stylesheet.num,
                                            {
                                                width: avatarSizes.xLarge - spaces.spacingMd
                                            }
                                        ]}
                                        variant="bodySmallSize"
                                        color="mid"
                                    >
                                        {t("blocks.forum01.colViews")}
                                    </Text>
                                    <Text
                                        style={{
                                            width: shapeConfigs.sideListWidth * 0.6
                                        }}
                                        variant="bodySmallSize"
                                        color="mid"
                                    >
                                        {t("blocks.forum01.colLast")}
                                    </Text>
                                </View>
                            :
                                null
                        }
                        {
                            isTable ?
                                <Separator/>
                            :
                                null
                        }
                        {threads.map(renderThread)}
                        <Separator/>
                        <View
                            style={{
                                paddingHorizontal: spaces.spacingMd
                            }}
                        >
                            <Pagination
                                unitTitle={t("blocks.forum01.unit")}
                                totalItems={TOTAL_THREADS}
                                onPageChange={setPage}
                                pageSize={PAGE_SIZE}
                                size="small"
                                page={page}
                            />
                        </View>
                    </Card>
                </View>
                <View
                    style={[
                        stylesheet.shrink,
                        {
                            width: isWide ? shapeConfigs.cardWidth : "100%",
                            gap: spaces.spacingMd,
                            flexGrow: 0
                        }
                    ]}
                >
                    <Card
                        variant="outline"
                    >
                        <Card.Header>
                            <Card.Title>
                                {t("blocks.forum01.summaryTitle")}
                            </Card.Title>
                        </Card.Header>
                        <Card.Content>
                            <View
                                style={[
                                    stylesheet.wrap,
                                    {
                                        gap: spaces.spacingMd
                                    }
                                ]}
                            >
                                {STATS.map(renderStat)}
                            </View>
                            <Separator/>
                            <View
                                style={[
                                    stylesheet.row,
                                    {
                                        gap: spaces.spacingSm
                                    }
                                ]}
                            >
                                <AvatarGroup
                                    avatars={READERS.map((person) => ({
                                        title: t(`blocks.forum01.person.${person}`)
                                    }))}
                                    size="xxSmall"
                                />
                                <Text
                                    variant="bodySmallSize"
                                    color="mid"
                                >
                                    {t("blocks.forum01.readers", [
                                        42
                                    ])}
                                </Text>
                            </View>
                        </Card.Content>
                    </Card>
                    <Card
                        variant="outline"
                    >
                        <Card.Header>
                            <Card.Title>
                                {t("blocks.forum01.rulesTitle")}
                            </Card.Title>
                        </Card.Header>
                        <Card.Content>
                            <Accordion
                                isCollapsible={true}
                                defaultValue="one"
                                variant="plain"
                            >
                                {RULES.map(renderRule)}
                            </Accordion>
                        </Card.Content>
                    </Card>
                    <Card
                        variant="outline"
                    >
                        <Card.Header>
                            <Card.Title>
                                {t("blocks.forum01.topTitle")}
                            </Card.Title>
                        </Card.Header>
                        <Card.Content>
                            {PEOPLE.map(renderPerson)}
                        </Card.Content>
                    </Card>
                </View>
            </View>
        </View>
    </ScrollView>;
};
export default Forum01;
